import { render, staticRenderFns } from "./ucap.vue?vue&type=template&id=66304493"
import script from "./ucap.vue?vue&type=script&lang=js"
export * from "./ucap.vue?vue&type=script&lang=js"
import style0 from "./ucap.vue?vue&type=style&index=0&id=66304493&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports